import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button } from 'antd'
import PoliciesTable from '../../../pages/PoliciesTable'
import { policyCollections } from '@services/api'

@inject((store: any) => {
    const { popupStore, authStore, collectionsStore } = store
    return { popupStore, authStore, collectionsStore }
})
@observer
export default class AddNewPolicyToCollection extends Component<any, any> {
    constructor(props) {
        super(props)
        this.closePopup = this.closePopup.bind(this)
        this.handleAddPolicyCollection = this.handleAddPolicyCollection.bind(this)
    }

    closePopup() {
        this.props.popupStore.togglePopup(false)
    }

    handleAddPolicyCollection = async record => {
        let { id } = record
        let collection_id = window.location.href.slice(window.location.href.split('/', 4).join('/').length + 1)
        await policyCollections.addCollection({ policy_id: id, collection_id })
        this.props.collectionsStore.getCollection(collection_id)
        this.closePopup()
    }

    render() {
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        const { popupType } = this.props.popupStore
        return (
            <Modal
                title={`קישור פוליסה לזכות`}
                visible={popupType === 'addNewPolicyToCollection'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                <PoliciesTable propCallback={this.handleAddPolicyCollection} />
            </Modal>
        )
    }
}
